export default {
  screens: [
    {
      type: 'intro',
      title: 'ショーメと日本',
      content:
        'ショーメはその創業当初から日本に魅了されてきました。多くの日本のお客様がショーメを選んでくださっていることを見れば、相互に魅了されてきたとも言えます。',
      idYt: 'vGycDLMlTz4',
      videoCover: 'world/japan/video.jpg',
      desktop: {
        cover: 'world/japan/cover-1.jpg'
      },
      mobile: {
        cover: 'world/japan/mobile-cover-1.jpg',
        contentStyle: {
          width: '100%'
        },
        coverStyle: {
          width: '100%',
          bottom: '0%',
          left: '0',
          right: 'inherit',
          position: 'relative'
        }
      }
    },
    {
      type: 'triangle',
      desktop: {
        topImg: 'world/japan/triangleTop.jpg',
        btmImg: 'world/japan/triangleBtm.jpg',
        cover: 'world/japan/cover-2.jpg'
      },
      mobile: {
        topImg: 'world/japan/mobileTriangleTop.jpg',
        btmImg: 'world/japan/triangleBtm.jpg',
        cover: 'world/japan/cover-2.jpg'
      },
      content:
        '王妃マリー=アントワネット所有の漆塗りを見たニトがそれに感動したこと、ジョゼフィーヌが日本の樹木を愛したことなどが、そうした始まりでした。以来ショーメは、日本がインスピレーションの源となるクリエーションを作り続けてきました。<br/><br/> 特別に作られたハイジュエリーコレクションには、ショーメと日本の深い関わりが見事に表現されています。',
      cover: 'world/japan/cover-2.jpg'
    },
    {
      type: 'column',
      leftImg: 'world/japan/columnLeft.jpg',
      middleImg: 'world/japan/columnMiddle.jpg',
      rightImg: 'world/japan/columnRight.jpg',
      title: 'Song of Spring',
      content:
        '「レ モンド ドゥ ショーメ」コレクション シャン ドゥ プランタン <br><br> 赤と黒の瑞々しい色、再び生まれる自然と幾何学的な純粋さが組み合わされたパリュールからは、日本文化の真髄が感じられます。'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/jp/worlds/japan.js